import React from "react";
import styled from "@emotion/styled";
import { useRouter } from "next/router";

import LoanCalculator from "shared/components/loan-calculator";
import { IRealestateResponseData } from "shared/models/interfaces/response/realestate.interface";
import useReadSessionStorage from "custom-hooks/useReadSessionStorage.hook";
import { loanUrlValuesAdapter } from "shared/models/adapters/loan.adapter";
import { CPagesPath } from "shared/models/const/pages-path";
import { useDetailPropertyContextHook } from "./context/DetailPropertyContext";
import useLeadCountMutation from "custom-hooks/useLeadCountMutation";
import leadsCounterAdapter from "@endpoints/clients/lead counter/lead.counter.adapter";
import { C_LEAD_TYPE } from "shared/models/enums/lead_type.enum";

const saleRegex = new RegExp("Venta", "gi");

function LoanCalculatorDetails(props: ILoanCalculatorDetails) {
  const { propertyDetail } = useDetailPropertyContextHook();
  const { ADD_LEAD_COUNT_M } = useLeadCountMutation();

  const { data, isCollection } = props;
  const router = useRouter();
  const code: any = useReadSessionStorage("code");

  if (data == undefined) {
    return null;
  }

  if (
    data.business_type.search(saleRegex) === -1 &&
    data.alternate_price <= 0
  ) {
    return null;
  }

  const onSubmit = (values: any) => {
    
    let agentCode: any = {};

    if (code && code.type) {
      agentCode = { [code.type]: code.id };
    }

    let queryValues = loanUrlValuesAdapter({
      ...values,
      ...agentCode,
      realestateId: data.id,
      propertyValue: data.price,
      currency: data.currency.symbol.toLowerCase(),
    });

    const url = CPagesPath.es.loan_form + "?" + queryValues + "#loanForm";

    router.push(url);
  };

  return (
    <Wrapper isCollection={isCollection} id="loanCalculator">
      <div className="container">
        <LoanCalculator
          initialPrice={data.price}
          currency={data.currency}
          disableLoanAmount
          onSubmit={onSubmit}
        />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section<IWrapper>`
  background-color: var(--white);
  scroll-margin: 40px;
  padding: ${(props) =>
    props.isCollection ? " 100px 0px 130px" : "47px 0px 130px"};
`;

interface ILoanCalculatorDetails {
  isCollection?: boolean;
  data: IRealestateResponseData | undefined;
}

interface IWrapper {
  isCollection?: boolean;
}

export default LoanCalculatorDetails;
